import InboundCaseInfo from './InboundCaseInfo'

export default InboundCaseInfo